(function() {
  // Only run on wholesale page
  if (window.location.pathname !== '/pages/wholesale') return;

  // Read tier from data attribute set by Liquid on body or a div
  var tierData = document.getElementById('ws-tier-data');
  if (!tierData) return;

  var customerTier = tierData.getAttribute('data-tier') || 'bronze';
  var tierMinOrder = parseInt(tierData.getAttribute('data-min-order')) || 50;
  var tierLabel = tierData.getAttribute('data-label') || 'Bronze';
  var kidsPrice = parseFloat(tierData.getAttribute('data-kids-price')) || 20.99;
  var adultPrice = parseFloat(tierData.getAttribute('data-adult-price')) || 24.49;

  document.addEventListener('DOMContentLoaded', function() {

    // Update prices displayed
    var kidsPriceEls = document.querySelectorAll('.ws-kids-price');
    var adultPriceEls = document.querySelectorAll('.ws-adult-price');
    kidsPriceEls.forEach(function(el) { el.textContent = '\u20ac' + kidsPrice.toFixed(2); });
    adultPriceEls.forEach(function(el) { el.textContent = '\u20ac' + adultPrice.toFixed(2); });

    // Update savings
    var kidsSavings = (29.99 - kidsPrice).toFixed(2);
    var adultSavings = (34.99 - adultPrice).toFixed(2);
    var kidsPct = Math.round((29.99 - kidsPrice) / 29.99 * 100);
    var adultPct = Math.round((34.99 - adultPrice) / 34.99 * 100);
    var kidsSavingsEl = document.getElementById('ws-kids-savings');
    var adultSavingsEl = document.getElementById('ws-adult-savings');
    if (kidsSavingsEl) kidsSavingsEl.textContent = 'You save \u20ac' + kidsSavings + ' per unit (' + kidsPct + '% off)';
    if (adultSavingsEl) adultSavingsEl.textContent = 'You save \u20ac' + adultSavings + ' per unit (' + adultPct + '% off)';

    // Highlight current tier card
    document.querySelectorAll('.tier-card').forEach(function(card) {
      card.style.border = '1px solid rgba(255,255,255,0.1)';
      card.style.opacity = '0.7';
      card.style.cursor = 'pointer';
    });
    var activeCard = document.querySelector('.tier-card[data-tier="' + customerTier + '"]');
    if (activeCard) {
      activeCard.style.border = '2px solid #20B2AA';
      activeCard.style.opacity = '1';
      activeCard.style.boxShadow = '0 0 30px rgba(32,178,170,0.3)';
    }

    // Tier card click — scroll to order form
    document.querySelectorAll('.tier-card').forEach(function(card) {
      card.addEventListener('click', function() {
        document.querySelectorAll('.tier-card').forEach(function(c) {
          c.style.border = '1px solid rgba(255,255,255,0.1)';
          c.style.opacity = '0.7';
        });
        card.style.border = '2px solid #20B2AA';
        card.style.opacity = '1';
        card.style.boxShadow = '0 0 30px rgba(32,178,170,0.3)';
        var form = document.getElementById('ws-order-form');
        if (form) form.scrollIntoView({behavior: 'smooth', block: 'start'});
      });
    });

    // Tier minimum label
    var minLabel = document.getElementById('tier-min-label');
    if (minLabel) minLabel.textContent = 'Your tier: ' + tierLabel + ' \u2014 Minimum: Kids flavours 20 units each | Adult 50 units | Total minimum ' + tierMinOrder + ' units';

    // Quantity input live subtotal
    document.querySelectorAll('.variant-qty-input').forEach(function(input) {
      input.addEventListener('input', updateTotals);
    });

    function updateTotals() {
      var total = 0;
      document.querySelectorAll('.variant-qty-input').forEach(function(input) {
        total += parseInt(input.value) || 0;
      });
      var totalEl = document.getElementById('ws-total-units');
      if (totalEl) totalEl.textContent = total + ' units';
    }

    // Add to Cart
    var cartBtn = document.getElementById('ws-add-to-cart');
    if (cartBtn) {
      cartBtn.addEventListener('click', function() {
        var errorBox = document.getElementById('ws-order-error');
        var successBox = document.getElementById('ws-order-success');
        if (errorBox) { errorBox.style.display = 'none'; errorBox.textContent = ''; }
        if (successBox) { successBox.style.display = 'none'; }

        var items = [];
        var totalUnits = 0;
        var errors = [];

        document.querySelectorAll('.variant-qty-input').forEach(function(input) {
          var qty = parseInt(input.value) || 0;
          var variantId = input.getAttribute('data-variant-id');
          var isAdult = input.getAttribute('data-product-type') === 'adult';
          var skuMin = isAdult ? 50 : 20;
          var label = input.getAttribute('data-label') || 'Product';

          if (qty > 0 && qty < skuMin) {
            errors.push(label + ': minimum ' + skuMin + ' units (you entered ' + qty + ')');
          }
          if (qty >= skuMin) {
            items.push({id: parseInt(variantId), quantity: qty});
            totalUnits += qty;
          }
        });

        if (errors.length > 0) {
          if (errorBox) { errorBox.textContent = errors.join(' | '); errorBox.style.display = 'block'; }
          return;
        }

        if (items.length === 0) {
          if (errorBox) { errorBox.textContent = 'Please add at least one product.'; errorBox.style.display = 'block'; }
          return;
        }

        if (totalUnits < tierMinOrder) {
          if (errorBox) { errorBox.textContent = 'Your ' + tierLabel + ' tier requires minimum ' + tierMinOrder + ' total units. You have ' + totalUnits + '.'; errorBox.style.display = 'block'; }
          return;
        }

        cartBtn.disabled = true;
        cartBtn.textContent = 'Adding to cart...';

        fetch('/cart/add.json', {
          method: 'POST',
          headers: {'Content-Type': 'application/json'},
          body: JSON.stringify({items: items})
        })
        .then(function(r) { return r.json(); })
        .then(function(data) {
          if (data.items) {
            if (successBox) { successBox.textContent = 'Added to cart! Redirecting...'; successBox.style.display = 'block'; }
            setTimeout(function() { window.location.href = '/cart'; }, 800);
          } else {
            if (errorBox) { errorBox.textContent = 'Error: ' + JSON.stringify(data); errorBox.style.display = 'block'; }
            cartBtn.disabled = false;
            cartBtn.textContent = 'Add to Cart \u2192';
          }
        })
        .catch(function(err) {
          if (errorBox) { errorBox.textContent = 'Cart error. Please try again.'; errorBox.style.display = 'block'; }
          cartBtn.disabled = false;
          cartBtn.textContent = 'Add to Cart \u2192';
        });
      });
    }
  });
})();
